import WalletTokensStats from "./WalletTokensStats";

export default WalletTokensStats;